/**
 * 桌面模态对话框(_shared C-5)。承载二次确认 / 卖家须知 / 申诉。
 * 契约:Esc = 取消语义、点遮罩关闭、打开时聚焦对话框(基础聚焦陷阱)。视觉用 app.css `.scrim`/`.dialog`。
 */
import { useEffect, useRef, type ReactNode } from 'react';

interface DialogProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  /** aria-labelledby 指向标题元素 id(可选)。 */
  labelledBy?: string;
}

export function Dialog({ open, onClose, children, labelledBy }: DialogProps) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return;
    ref.current?.focus();
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="scrim"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        ref={ref}
        className="dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby={labelledBy}
        tabIndex={-1}
      >
        {children}
      </div>
    </div>
  );
}
